// src/utils/itemCode.js
// P4-5 (30 Oct 2026, D-319 decision 3) - the item code formula, in ONE place.
//
// WHY THIS FILE EXISTS
// itemService.createItem() (new items) and the P4-5 repair script (old items
// with a duplicate code) must build exactly the same code. The script is plain
// Node and cannot import itemService.js, which needs Firebase, so the formula
// lives here with no imports at all. itemService.js re-exports it.
// Pure -> covered by src/services/itemService.test.js and itemCodeRepair.test.js.

export const CATEGORY_PREFIX = { MATERIAL: "MT", TOOLS: "TL", CONSUMABLE: "CS", ASSET: "AS" };

const clean = (v) => String(v ?? "").trim();

// "MT-100123" from ("MATERIAL", "ITEM-100123"). AS- / TL- keep the existing
// exclusion filters (StockAdjustment, MaterialSummary) working.
export const itemCodeFor = (category, item_id) => {
  const m = /^ITEM-(\d+)$/.exec(clean(item_id));
  if (!m) throw new Error(`An item code needs an item id like ITEM-100123 (got "${clean(item_id)}").`);
  const prefix = CATEGORY_PREFIX[clean(category).toUpperCase()] || "IT";
  return `${prefix}-${m[1]}`;
};
